import React from 'react';

const SelectModal = ({
    isVisible,
    onClose,
    title,
    children,
    showButtons = true,
    confirmText = "확인",
    cancelText = "취소",
    onConfirm,
    confirmDisabled = false,
    isLoading = false
}) => {
    if (!isVisible) return null;

    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        } else {
            onClose();
        }
    };

    return (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
            <div className="bg-white rounded-lg p-6 m-4 w-full max-w-sm">
                {title && (
                    <h3 className="text-lg font-semibold mb-4 text-center">{title}</h3>
                )}

                {/* 컨텐츠 영역 */}
                <div className="mb-6">
                    {children}
                </div>

                {/* 버튼 영역 */}
                {showButtons && (
                    <div className="flex space-x-3">
                        <button
                            onClick={onClose}
                            className="flex-1 py-3 bg-gray-100 text-gray-700 rounded-lg active:bg-gray-200"
                            disabled={isLoading}
                        >
                            {cancelText}
                        </button>
                        <button
                            onClick={handleConfirm}
                            disabled={confirmDisabled || isLoading}
                            className={`flex-1 py-3 rounded-lg font-medium ${
                                !confirmDisabled && !isLoading
                                    ? 'bg-amber-500 text-white active:bg-amber-600'
                                    : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                            }`}
                        >
                            {isLoading ? '처리 중...' : confirmText}
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
};

export default SelectModal;
